import React from "react";
import { Server } from "@modules/api";
import { SubmitHandler, useForm } from "react-hook-form";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@ui/dialog";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { Input } from "@ui/input";
import TranslatedTextTemp from "@components/items/display/TranslatedTextTemp";
import { createPlaylist, useAppDispatch } from "@lib/stores";
import TranslatedText from "@components/items/display/TranslatedText";
import { getPaginatedPlaylistsAsync } from "@lib/stores/myLibrary/slices";

const PAGE_SIZE = 5;
const CreatePlaylistDialog = ({
  isOpen,
  setOpen,
}: {
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const dispatch = useAppDispatch();

  const { register, handleSubmit, reset } = useForm<{ title: string }>();

  const onSubmit: SubmitHandler<{ title: string }> = (data) => {
    try {
      const { title } = data;
      createPlaylist({ title }, () => {
        dispatch(
          getPaginatedPlaylistsAsync({
            PageNumber: 1,
            PageSize: PAGE_SIZE,
            SortBy: Server.SortBy.MostRecent,
          })
        );
        setOpen(false);
      });
      reset();
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <Dialog open={isOpen}>
      <DialogContent className="flex w-3/4 flex-col items-center justify-center gap-5 bg-white py-8 sm:w-1/3 dark:border-none dark:bg-[#37383F] [&>button]:hidden">
        <DialogHeader className="flex flex-col items-center justify-center gap-2">
          <DialogTitle>
            <TranslatedText
              text={`my-library.${"create your own unique lists"}`}
              className="text-center dark:text-white"
            />
          </DialogTitle>
          <DialogDescription>
            <TranslatedText
              text={`my-library.${"add a name to the playlist"}`}
              className="text-center dark:text-white"
            />
          </DialogDescription>
        </DialogHeader>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex w-full flex-col items-center justify-center gap-4"
        >
          <DialogDescription className="flex w-full items-center justify-center">
            <Input
              {...register("title", { required: true })}
              className="w-[90%] bg-[#D9D9D9] text-black focus-visible:ring-0 focus-visible:ring-offset-0"
            />
          </DialogDescription>
          <DialogFooter>
            <ShadcnButton
              type="button"
              className="bg-trasparent hover:bg-trasparent text-primary focus-visible:ring-0 focus-visible:ring-offset-0"
              onClick={() => setOpen(false)}
            >
              <TranslatedTextTemp text={`my-library.buttons.${"cancel"}`} />
            </ShadcnButton>
            <ShadcnButton
              type="submit"
              className="rounded-xl text-white focus-visible:ring-0 focus-visible:ring-offset-0"
            >
              <TranslatedTextTemp text={`my-library.buttons.${"create"}`} />
            </ShadcnButton>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default CreatePlaylistDialog;
